<!-- eslint-disable vue/no-v-html -->
<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-width="220px"
    class="demo-ruleForm"
  >
    <el-tabs
      v-model="activeName"
      type="border-card"
      @tab-click="handleTabsClick"
    >
      <el-tab-pane label="商家基本信息" name="first">
        <el-form-item label="商家id">
          <el-input v-model="form.supply_id" :disabled="true" />
        </el-form-item>
        <el-form-item label="商家名称">
          <el-input v-model="form.supply_name" :disabled="true" />
        </el-form-item>
        <!-- <el-form-item
          label="是否开通按计划点货"
          prop="take_stock_on_plan"
          required
        >
          <el-select
            v-model="form.take_stock_on_plan"
            placeholder="是否开通按计划点货"
          >
            <el-option
              v-for="item in take_stock_on_plan_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="商家性质" prop="supply_character">
          <el-select
            v-model="form.supply_character"
            style="width: 200px"
            placeholder="商家性质"
            :disabled="true"
          >
            <el-option
              v-for="item in supply_character_type"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            style="margin-left: 8px"
            @click.prevent="supplyCharacterVisible = true"
          >
            修改
          </el-button>
        </el-form-item>
        <el-form-item label="是否可刷单" prop="is_scal">
          <el-select v-model="form.is_scal" placeholder="是否可刷单">
            <el-option
              v-for="item in is_scal_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="商家状态" prop="supply_status">
          <el-select
            v-model="form.supply_status"
            placeholder="商家状态"
            disabled
            @change="changeStatus"
          >
            <el-option
              v-for="item in supply_status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            type="primary"
            style="margin-left: 8px"
            size="default"
            @click="supplyStatusFormModalVisible = true"
            >修改</el-button
          >
        </el-form-item>
        <el-dialog
          title="修改商家状态"
          :visible.sync="supplyStatusFormModalVisible"
          width="30%"
          @close="handleSupplyStatusModalClose"
        >
          <div v-if="form.supply_status.toString() === '0'">
            当前商家状态为<span style="color: #f56c6c">「禁用」</span
            >，需要改成<span style="color: #67c23a">「启用」</span>？
          </div>
          <div v-if="form.supply_status.toString() === '1'">
            当前商家状态为<span style="color: #67c23a">「启用」</span
            >，需要改成<span style="color: #f56c6c">「禁用」</span>？
          </div>
          <el-form
            ref="supplyStatusFormRef"
            :model="supplyStatusForm"
            :rules="supplyStatusFormRules"
            label-width="120px"
            :inline="false"
            label-position="top"
            size="normal"
          >
            <el-form-item label="请填写备注（必填）" prop="remark">
              <el-input
                v-model="supplyStatusForm.remark"
                placeholder="属于审计监控内容，请如实填报！"
              ></el-input>
            </el-form-item>
          </el-form>

          <span slot="footer">
            <el-button @click="handleSupplyStatusModalClose">取消</el-button>
            <el-button type="primary" @click="handleSupplyStatusModalConfirm">
              确定</el-button
            >
          </span>
        </el-dialog>

        <el-dialog
          title="提示"
          :visible.sync="statusVisible"
          width="30%"
          :before-close="handleClose"
        >
          <el-form :model="form">
            <p v-if="form.supply_status == 0">
              <i
                class="el-icon-warning"
                style="color: orange"
              />&nbsp;禁用后，该品牌下的所有商品将变为“断货”状态
              <span v-if="baobmobile">，商家爆版一手功能权限将关闭！</span>
            </p>
            <el-form-item label="请填写备注">
              <el-input
                v-model="form.status_remark"
                placeholder="备注"
                type="textarea"
              />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button
              @click="
                statusVisible = false;
                form.supply_status = 1;
              "
            >
              取 消
            </el-button>
            <el-button type="primary" @click="statusVisible = false">
              确 定
            </el-button>
          </span>
        </el-dialog>

        <el-form-item label="交易方式" prop="settle_type">
          <div style="display: flex; flex-direction: row">
            <div>
              <el-select
                v-model="form.settle_type"
                style="width: 200px"
                placeholder="交易方式"
                :disabled="true"
              >
                <el-option
                  v-for="item in settle_type"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <supply-select
              v-if="form.settle_type == 2"
              :data="{
                is_signed_contract: form.is_signed_contract,
                settle_days: form.settle_days,
              }"
              @returnData="returnData"
            />
          </div>
        </el-form-item>

        <el-form-item label="支付方式" prop="is_self">
          <!-- 单独权限，不能直接切换 -->
          <el-select
            v-model="form.pay_method"
            :disabled="true"
            placeholder="支付方式"
          >
            <el-option
              v-for="item in options.pay_methods"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button type="primary" @click="handlePayMethodExchange">
            切换至{{ otherPay.label || "" }}</el-button
          >
        </el-form-item>

        <el-form-item label="合并账单日期" prop="bill_merger_date">
          <el-select
            v-model="form.bill_merger_date"
            style="width: 200px"
            multiple
            placeholder="合并账单日期"
          >
            <el-option
              v-for="item in Date_list"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          <span class="select-option-tips">
            填写后，商家前置仓账单会根据每月已填写的日期进行自动合并。
          </span>
        </el-form-item>
        <el-form-item label="活动费扣取方式" prop="activity_fee_buckle">
          <el-radio v-model="form.activity_fee_buckle" label="1">
            账单方式
          </el-radio>
          <span class="activity-free-buckle-span"
            >选择此结算方式，商家活动费在账单中扣取。</span
          >
          <div>
            <el-switch
              v-if="form.activity_fee_buckle === '1'"
              v-model="form.open_qz_auto_buckle"
              active-value="1"
              inactive-value="2"
            >
            </el-switch>
            前置仓账单扣取
            <span class="open-qz-span">
              *若开启，则活动费抵扣可在前置仓代采订单中扣取，否则前置仓代采订单不自动扣取活动费。
            </span>
          </div>
        </el-form-item>
        <template v-if="form.is_platform !== constantMap.isPlatform">
          <el-form-item prop="is_return_profit">
            <span slot="label">
              折扣让利（佣金）
              <el-tooltip effect="light">
                <div slot="content">
                  商家签订折扣让利协议后，按月销量达标的商品由商家让利给一手平台。
                </div>
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-radio-group v-model="form.is_return_profit">
              <el-radio label="1"> 参与 </el-radio>
              <el-radio label="2"> 不参与 </el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.is_return_profit === constantMap.isJoinProfit">
            <el-form-item
              label="让利账单生成周期 "
              prop="period_profit"
              required
            >
              <el-select
                v-model="form.period_profit"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in periodProfitStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <span>
                如商家当前已经参与此协议，在切换账期模式后，本月仍保持旧的账期规则，直到下个月1号才会按新设置生效。若商家没参加过协议，或协议关闭已经超过一个月了，则马上生效。
              </span>
            </el-form-item>
            <el-form-item
              label="生效时间"
              prop="return_profit_month"
              :rules="commonRules.ruleChange"
            >
              <el-date-picker
                v-model="form.return_profit_month"
                :picker-options="constantMap.pickerOptions"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择生效时间"
              >
              </el-date-picker>
              <span style="color: gray">
                在生效日期起代采开单且发货出库的商品将进行让利销量统计，历史数据请在让利销量汇总表补生成
              </span>
            </el-form-item>
            <el-form-item
              label="结算方式"
              prop="clearing_form"
              :rules="commonRules.ruleChange"
            >
              <el-radio-group v-model="form.clearing_form">
                <el-radio label="1"> 代采单抵扣 </el-radio>
                <el-radio label="2"> 账单支付 </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="商品名单"
              prop="return_profit_goods_type"
              :rules="commonRules.ruleChange"
            >
              <el-radio-group v-model="form.return_profit_goods_type">
                <el-radio label="1"> 所有商品 </el-radio>
                <el-radio label="2"> 指定货号 </el-radio>
              </el-radio-group>
              <el-upload
                v-show="form.return_profit_goods_type === '2'"
                ref="goodsTypeFileRef"
                style="margin: 0 10px 2px; display: flex"
                :action="actionFile"
                name="file"
                :data="uploadParm"
                :limit="1"
                :on-exceed="limitTips"
                :on-success="importFile"
                :file-list="goodsTypeFile"
                auto-upload
                with-credentials
              >
                <el-button type="primary" size="small">上传文件</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item
              label="商品要求"
              prop="reserve_price"
              :rules="commonRules.ruleBlur"
            >
              <YsInput
                v-model="form.reserve_price"
                pattern="money"
                style="min-width: 50%"
                size="small"
              >
                <span slot="prepend"> 非特价、且商家价&gt; </span>
                <span slot="append">元/件</span>
              </YsInput>
            </el-form-item>
            <el-form-item
              label="让利单价设置"
              prop="return_profit_rule"
              :rules="[commonRules.ruleChangeArray]"
            >
              <el-button
                type="primary"
                size="small"
                @click="handleReturnProfitRuleAdd"
              >
                添加设置行
              </el-button>
              <el-table :data="form.return_profit_rule" border size="mini">
                <el-table-column align="center" label="序号" width="80">
                  <template #default="{ $index }">
                    {{ $index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="num"
                  align="center"
                  label="月度销售件数达标门槛（按商品货号）"
                >
                  <el-form-item
                    slot-scope="{ row, $index }"
                    :prop="`return_profit_rule.${$index}.num`"
                    :rules="commonRules.ruleBlur"
                  >
                    <YsInput
                      v-model="row.num"
                      pattern="positiveInt"
                      size="small"
                    >
                      <span slot="prepend">达到</span>
                      <span slot="append">件及以上时</span>
                    </YsInput>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="price" align="center" label="让利单价">
                  <el-form-item
                    slot-scope="{ row, $index }"
                    :prop="`return_profit_rule.${$index}.price`"
                    :rules="rulePrice"
                  >
                    <YsInput v-model="row.price" pattern="money" size="small">
                      <span slot="append">元/件</span>
                    </YsInput>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  align="center"
                  label="操作"
                  width="100"
                >
                  <el-form-item slot-scope="{ $index }">
                    <el-button
                      v-if="form.return_profit_rule.length > 1"
                      type="danger"
                      size="small"
                      @click="handleReturnProfitRuleDel($index)"
                    >
                      删除
                    </el-button>
                  </el-form-item>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>
        </template>
        <el-form-item label="商家邀约规则设置">
          <el-table
            :data="invitationRule.rule"
            border
            size="mini"
            style="width: 800px"
          >
            <el-table-column align="center" label="规则序号">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="invitation_category"
              align="center"
              label="商品分类"
            />
            <el-table-column
              prop="forecast_days"
              align="center"
              label="前置仓备货天数"
            />
            <el-table-column
              prop="is_underwriting"
              align="center"
              label="是否加流"
            >
              <template #default="scope">
                <div>
                  {{
                    scope.row.is_underwriting === constantMap.OPEN ? "是" : "否"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="no_pre_storage_forecast_days"
              align="center"
              label="非前置仓备货天数"
            />
          </el-table>
          <el-button
            style="margin-top: 8px"
            type="primary"
            @click="handleInvitationRuleEdit"
          >
            编辑
          </el-button>
        </el-form-item>
        <el-form-item label="城市 " prop="city">
          <el-select
            v-model="form.city"
            filterable
            placeholder="城市"
            @change="handleSelectCity($event, true)"
          >
            <el-option
              v-for="item in citys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="市场（地理位置）" prop="father_market">
          <el-select
            v-model="form.father_market"
            filterable
            placeholder="市场"
            @change="setChild($event, true)"
          >
            <el-option
              v-for="item in marketList"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="子市场（地理位置）" prop="market_id">
          <el-select v-model="form.market_id" filterable placeholder="子市场">
            <el-option
              v-for="item in subMarketList"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="attributable_market_id">
          <span slot="label">
            业绩归属市场
            <el-tooltip effect="light">
              <div slot="content">用于统计公司内部各市场部门的业绩销售情况</div>
              <i class="el-icon-question" />
            </el-tooltip>
          </span>
          <el-select
            v-model="form.attributable_market_id"
            filterable
            placeholder="业绩归属市场"
            @change="handleSetAttributableSubMarket($event, true)"
          >
            <el-option
              v-for="item in performanceMarketList"
              :key="item.attributable_market_id"
              :label="item.attributable_market_name"
              :value="item.attributable_market_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="业绩归属细分市场"
          prop="attributable_market_sub_id"
        >
          <el-select
            v-model="form.attributable_market_sub_id"
            filterable
            placeholder="业绩归属细分市场"
          >
            <el-option
              v-for="item in performanceSubMarketList"
              :key="item.sub_id"
              :label="item.sub_name"
              :value="item.sub_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="楼层" prop="supply_floor">
          <el-select
            v-model="form.supply_floor"
            filterable
            placeholder="楼层"
            @change="genSupplyName"
          >
            <el-option
              v-for="item in floor"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="区域/街" prop="supply_area_id">
          <el-select
            v-model="form.supply_area_id"
            filterable
            placeholder="区域/街"
            @change="genSupplyName"
          >
            <el-option
              v-for="item in supply_area_list"
              :key="item.supply_area_id"
              :label="item.supply_area"
              :value="item.supply_area_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="档口号" prop="supplier_num">
          <el-autocomplete
            v-model="form.supplier_num"
            class="inline-input"
            :fetch-suggestions="querySearch"
            placeholder="请输入档口号"
            @select="handleSelect"
            @blur="genSupplyName"
          />
          <!--<el-input v-model="form.supply_name"></el-input>-->
        </el-form-item>

        <el-form-item label="一手商城档口名">
          <el-input
            v-model="form.supply_nickname"
            placeholder="显示于档口形象图上面的昵称（最多10个中文字）"
          />
        </el-form-item>
        <el-form-item label="品牌" prop="brand">
          <el-input
            v-model="form.brand"
            :disabled="true"
            style="width: 50%; float: left"
          />
          <el-button @click.prevent="brandVisible = true"> 编辑 </el-button>
        </el-form-item>

        <el-form-item label="代采组" prop="pgid">
          <el-select
            v-model="form.pgid"
            filterable
            placeholder="代采组"
            @change="getMemberOption"
          >
            <el-option
              v-for="item in pg_list"
              :key="item.pgid"
              :label="item.pgname"
              :value="item.pgid"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="代采员" prop="pg_member_id">
          <el-select
            v-model="form.pg_member_id"
            filterable
            placeholder="代采员"
          >
            <el-option key="0" value="0" label="全部" />
            <el-option
              v-for="item in memberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="次品组" prop="dgid">
          <el-select
            v-model="form.dgid"
            placeholder="次品组"
            filterable
            @change="getDefectiveGroupMember"
          >
            <el-option key="0" value="0" label="请选择" />
            <el-option
              v-for="item in defectiveGroupOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="次品员" prop="dg_member_id">
          <el-select
            v-model="form.dg_member_id"
            filterable
            placeholder="次品组"
          >
            <el-option key="0" value="0" label="请选择" />
            <el-option
              v-for="item in defectiveGroupMemberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="售后退供员" prop="refund_member_id">
          <el-select
            v-model="form.refund_member_id"
            filterable
            placeholder="售后退供员"
          >
            <el-option key="0" value="0" label="请选择" />
            <el-option
              v-for="item in refundMemberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="买手组" prop="pg_id">
          <el-select
            v-model="form.pg_id"
            filterable
            placeholder="买手组"
            @change="getPickerGroupMemberOption"
          >
            <el-option key="0" value="0" label="无" />
            <el-option
              v-for="item in pickers"
              :key="item.pg_id"
              :label="item.pg_name"
              :value="item.pg_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="买手" prop="supply_picker_group_member_id">
          <el-select
            v-model="form.supply_picker_group_member_id"
            filterable
            placeholder="买手"
          >
            <el-option key="0" value="0" label="无" />
            <el-option
              v-for="item in PickerGroupMemberOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="商家运营跟进人" prop="follower">
          <el-select
            v-model="form.follower_admin_id"
            filterable
            placeholder="商家运营跟进人"
          >
            <el-option key="0" value="0" label="请选择" />
            <el-option
              v-for="item in resData.follower || []"
              :key="item.value"
              :disabled="item.admin_status == 0"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="商家拓展跟进人" prop="follower">
          <el-select
            v-model="form.expand_admin_id"
            filterable
            placeholder="商家拓展跟进人"
          >
            <el-option key="0" value="0" label="请选择" />
            <el-option
              v-for="item in resData.follower || []"
              :key="item.value"
              :disabled="item.admin_status == 0"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="商家开发人" prop="supply_developer">
          <el-select
            v-model="form.supply_developer_admin"
            filterable
            placeholder="商家开发人"
            :disabled="current_developer != 0"
          >
            <el-option
              v-for="item in supply_developer"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="前置仓跟进人" prop="pre_storage_admin">
          <el-select
            v-model="form.pre_storage_admin"
            filterable
            placeholder="前置仓跟进人"
          >
            <el-option
              v-for="item in resData.pre_storage_admin_list"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="商品默认活跃值" prop="supply_action_value">
          <el-input
            v-model="form.supply_action_value"
            style="width: 45%"
            placeholder="商家新建商品默认活跃值"
          />
        </el-form-item>
        <el-form-item label="排单锁定天数" prop="limit_day">
          <el-input v-model="form.limit_day" type="number" style="width: 200px">
            <template #append> 天 </template>
          </el-input>
        </el-form-item>
        <el-form-item label="超时断计划" prop="plan_time_out_days">
          <ys-input
            v-model="form.plan_time_out_days"
            pattern="positiveInt"
            min="1"
            max="999"
            style="width: 200px"
          >
            <template #append> 天 </template>
          </ys-input>
          <span>
            超过（大于）设定天数未开单且无客需的
            <span style="color: #f00">系统计划</span>
            及
            <span style="color: #f00">重采计划</span>
            （数量不足来源）以及
            <span style="color: #f00">虚拟库存采购计划</span>
            自动断待开单。
          </span>
        </el-form-item>
        <el-form-item label="前置仓包销商品寄售期" prop="">
          <ys-input
            v-model="form.pre_consignment_period"
            pattern="int"
            min="0"
            style="width: 200px"
          >
            <template #append> 天 </template>
          </ys-input>
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit"> 提交 </el-button>
        </el-form-item>

        <el-dialog
          title="品牌信息"
          :visible.sync="brandVisible"
          width="60%"
          center
        >
          <el-form :model="form">
            <el-form-item label="前端是否显示品牌名">
              <el-switch
                v-model="form.is_show_brand"
                inactive-color="#ff4949"
                active-color="#13ce66"
                inactive-value="0"
                active-value="1"
                inactive-text="不显示"
                active-text="显示"
              />
            </el-form-item>
            <el-form-item
              v-for="(brand, index) in form.brands"
              :key="brand.brand_id + index"
              :label="'品牌' + (index + 1)"
              :prop="'brands.' + index + '.brand_name'"
            >
              <span style="float: left; margin-right: 10px">
                品牌id:{{ brand.brand_id }}
              </span>
              <el-input
                v-model="brand.brand_id"
                placeholder="brand_id"
                style="display: none"
              />
              <el-input
                v-model="brand.brand_name"
                placeholder="品牌名"
                style="width: 60%; float: left"
              />
              <el-radio
                v-model="form.is_main"
                :label="index"
                :disabled="brand.status != 1"
                @change="genSupplyName()"
              >
                主品牌
              </el-radio>
              <el-button
                size="small"
                :type="brand.status == 1 ? 'success' : 'danger'"
                @click="changeBrand(brand)"
              >
                {{ brand.status == 1 ? "已启用" : "已禁用" }}
              </el-button>
            </el-form-item>
            <el-button @click="addBrand"> 增加品牌 </el-button>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="brandVisible = false"> 取 消 </el-button>
            <el-button type="primary" @click="setBrand"> 确 定 </el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="商家性质"
          :visible.sync="supplyCharacterVisible"
          width="60%"
          center
        >
          <div style="margin-left: 40px; margin-top: 20px">
            <el-radio
              v-for="item in supply_character_type"
              :key="item.value"
              v-model="plan_supply_character"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleResetSupplyCharacter"> 取 消 </el-button>
            <el-button type="primary" @click="handleSetSupplyCharacter">
              确 定
            </el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="商家权限" name="second">
        <limit-of-supply
          v-if="activeName === 'second'"
          :supply-data="form"
          :refund-models="refundModels"
          @submit="limitOfSupplySubmit"
        />
        <el-form-item
          label="自主上款是否需要审核"
          prop="is_self_need_audit"
          style="display: none"
        >
          <el-select
            v-model="form.is_self_need_audit"
            placeholder="自主上款是否需要审核"
            :disabled="true"
            @change="setSelfNeedAudit"
          >
            <el-option
              v-for="item in is_self_need_audit"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="平台化设置" name="platforming" :lazy="true">
        <platforming ref="platforming" :supply-id="form.supply_id" />
      </el-tab-pane>
      <el-tab-pane label="商家标签" name="third">
        <el-form-item label="擅长季节" prop="season">
          <el-checkbox-group v-model="form.season" lable="擅长季节">
            <el-checkbox label="春季" />
            <el-checkbox label="夏季" />
            <el-checkbox label="秋季" />
            <el-checkbox label="冬季" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="适合年龄阶段" prop="season">
          <el-checkbox-group v-model="form.age_group">
            <el-checkbox
              v-for="age in age_group_list"
              :key="age.key"
              :label="age.key"
            >
              {{ age.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="档次" prop="supply_grade">
          <el-checkbox-group v-model="form.supply_grade" lable="档次">
            <el-checkbox label="低端" />
            <el-checkbox label="中低" />
            <el-checkbox label="中端" />
            <el-checkbox label="中高" />
            <el-checkbox label="高端" />
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="擅长品类">
          <el-cascader
            v-model="form.cat_ids"
            placeholder="搜索品类"
            :options="category"
            :props="{ multiple: true }"
            filterable
          />
        </el-form-item>

        <el-form-item label="主要风格">
          <el-transfer
            v-model="form.styles"
            filterable
            :titles="['选项', '选中']"
            filter-placeholder="请输入风格"
            :data="styles_data"
            @change="build_second_styles"
          />
        </el-form-item>
        <el-form-item label="副风格">
          <el-transfer
            v-model="form.second_styles"
            filterable
            :titles="['选项', '选中']"
            filter-placeholder="请输入风格"
            :data="second_styles_data"
            @change="build_styles"
          />
        </el-form-item>
        <el-form-item label="推荐描述">
          <el-input
            v-model="form.recommend_desc"
            style="width: 40%; float: left"
            maxlength="100"
          />
          <span style="color: red"
            >一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）</span
          >
        </el-form-item>
        <el-form-item label="品牌介绍">
          <el-input
            v-model="form.pg_say"
            placeholder="说点什么呢~"
            style="width: 40%; float: left"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit"> 提交 </el-button>
        </el-form-item>
      </el-tab-pane>
      <el-tab-pane label="商家经营信息" name="BusinessInfo" :lazy="true">
        <template v-if="isShowManagement">
          <el-form-item label="微信联系方式">
            <el-col :span="24" style="width: 100%">
              <UploadCommonTemplate
                v-model="form.wx_picture"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
            <el-input
              v-model="form.wx_no"
              placeholder="录入微信号"
              style="width: 25%; float: left"
            />
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              v-model="form.supply_mobile_phone"
              placeholder="手机"
              style="width: 25%; float: left"
            />
            <el-input
              v-model="form.supply_wechat"
              placeholder="微信"
              style="width: 25%; float: left"
            />
          </el-form-item>
          <el-form-item
            v-for="(payee, index) in form.payees"
            :key="payee.key"
            :label="'收款人信息' + (index + 1)"
          >
            <el-input
              disabled
              :value="
                payee.payee_name +
                '-' +
                payee.payee_bank +
                '-' +
                payee.cnap_name +
                '-' +
                payee.payee_bank_account
              "
              style="width: 70%"
            />
            <el-radio
              v-model="form.is_default"
              :label="index"
              @change="setDefaultPayee(payee)"
            >
              默认收款账号
            </el-radio>
            <el-button @click.prevent="updatePayee(payee)"> 编辑 </el-button>
            <el-button @click.prevent="removePayee(payee)"> 删除 </el-button>
          </el-form-item>
          <el-button @click="updatePayee()"> 增加收款人 </el-button>

          <el-dialog
            title="修改付款信息"
            :visible.sync="savePayeeVisible"
            width="60%"
            center
          >
            <el-form>
              <el-form-item label="收款人姓名">
                <el-input
                  v-model="spayee.payee_name"
                  placeholder="请输入收款人姓名"
                  style="width: 80%; float: right"
                />
              </el-form-item>
              <el-form-item label="收款人银行">
                <el-select
                  v-model="spayee.payee_bank"
                  filterable
                  placeholder="收款银行"
                  style="width: 80%; float: right"
                >
                  <el-option
                    v-for="item in banks"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="收款人支行">
                <el-select
                  v-model="spayee.cnap"
                  filterable
                  remote
                  :remote-method="setCnap"
                  placeholder="所属支行（若不确定，选用“xx营业部”或“xx分行”"
                  style="width: 80%; float: right"
                >
                  <el-option value=""> 请选择 </el-option>
                  <el-option
                    v-for="item in cnaps"
                    :key="item.cnap"
                    :label="item.cnap_name"
                    :value="item.cnap"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="收款人银行账号">
                <el-input
                  v-model="spayee.payee_bank_account"
                  placeholder="请输入收款人银行账号"
                  style="width: 80%; float: right"
                />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="savePayeeVisible = false"> 取 消 </el-button>
              <el-button type="primary" @click="savePayee()"> 确 定 </el-button>
            </div>
          </el-dialog>
          <el-form-item label="身份证正面">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.front_id_card"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="身份证反面">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.back_id_card"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="待结算证明">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.settle_certificate"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="档口线下实力分级">
            <el-select v-model="form.supply_level" placeholder="爆版店铺">
              <el-option
                v-for="item in level_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="一手店铺底图">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.pic"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="档口实拍图">
            <el-col :span="24" style="width: 100%">
              <UploadCommonTemplate
                v-model="form.picture"
                :origin="origin"
                :limit="9"
                @preview-image="previewImage"
              />
            </el-col>
            <el-col>
              <span style="color: #999">
                单张图片不要超过10M，最多可上传9张图片
              </span>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌logo">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.avatar"
                :origin="origin"
                model-name="avatar"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="档口海报图">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.posters"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="营业执照">
            <el-col :span="24" :style="'width:100%;'">
              <UploadCommonTemplate
                v-model="form.license"
                :origin="origin"
                @preview-image="previewImage"
              />
            </el-col>
          </el-form-item>
          <el-form-item label="工作室照片">
            <el-col :span="24" :style="'width:100%;'">
              <el-upload
                :style="'width:100px;float:left;height:50px;'"
                class="upload-demo"
                :show-file-list="false"
                :action="uploadActionUrl"
                :data="uploadData"
                style="display: inline-block; margin-right: 10px"
                multiple
                accept="image/*"
                :on-success="uploadSuccess"
                :on-remove="handleRemove"
                :before-upload="beforeStudioPhotosUpload"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :limit="9"
                :disabled="videoFlag"
                :on-change="handleChange"
                :on-error="handleError"
              >
                <el-button
                  size="small"
                  style="margin: 10px 3px"
                  type="primary"
                  :disabled="videoFlag"
                >
                  上传图片
                </el-button>
              </el-upload>
              <template v-if="form.studioPhotos.length > 0">
                <div
                  v-for="(url, index) in form.studioPhotos"
                  :key="index"
                  style="
                    float: left;
                    width: 50px;
                    height: 50px;
                    margin: 0 10px;
                    border: 1px solid #ddd;
                  "
                >
                  <div style="position: relative">
                    <img
                      style="width: 50px; height: 50px; cursor: pointer"
                      :src="url"
                      @click="previewStudioPhoto(url)"
                    />
                    <div
                      style="
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top: -5px;
                        right: -5px;
                        cursor: pointer;
                        display: flex;
                      "
                      @click="deleteImg(url, index)"
                    >
                      <img
                        style="width: 15px; height: 15px"
                        :src="origin + '/201804/13/15235857625ad012e238658.png'"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </el-col>
            <el-col>
              <span style="color: #999">
                单张图片不要超过10M，最多可上传9张图片
              </span>
            </el-col>
          </el-form-item>
          <el-form-item label="商家视频">
            <el-col :span="24" :style="'width:100%;'">
              <el-upload
                :style="'width:100px;float:left;height:50px;'"
                class="upload-demo"
                :show-file-list="false"
                :action="uploadActionUrl"
                :data="uploadData"
                multiple
                style="display: inline-block; margin-right: 10px"
                accept="video/*"
                :on-success="uploadSuccessVideo"
                :before-upload="beforeVideoUpload"
                :on-progress="uploadVideoProcess"
                :file-list="files"
              >
                <el-button size="small" style="margin: 10px 3px" type="primary">
                  上传视频
                </el-button>
              </el-upload>
              <div
                v-if="supply_video != ''"
                style="
                  float: left;
                  width: 50px;
                  height: 50px;
                  margin: 0 10px;
                  border: 1px solid #ddd;
                "
              >
                <div style="position: relative">
                  <video
                    style="width: 50px; height: 50px"
                    :src="supply_video"
                    @click="handleViewVideo(supply_video)"
                  />
                  <div
                    style="
                      width: 15px;
                      height: 15px;
                      position: absolute;
                      top: -5px;
                      right: -5px;
                    "
                    @click="deleteVideo()"
                  >
                    <img
                      style="width: 15px; height: 15px"
                      :src="origin + '/201804/13/15235857625ad012e238658.png'"
                    />
                  </div>
                </div>
              </div>
              <el-progress
                v-if="videoFlag == true"
                type="circle"
                :percentage="videoUploadPercent"
                style="margin-top: 30px"
              />
            </el-col>
            <el-col>
              <span style="color: #999">
                视频不要超过50M，最多可上传1个视频
              </span>
            </el-col>
          </el-form-item>

          <el-form-item label="合同/协议管理">
            <el-col :span="24" :style="'width:100%;'">
              <el-button
                size="small"
                style="margin: 10px 3px"
                type="primary"
                @click="addContractVisible = true"
                >添加线下合同</el-button
              >
            </el-col>
            <el-col
              v-if="contract.length > 0"
              :span="24"
              :style="'width:100%;'"
            >
              <el-table
                v-if="isContractUpdate"
                :data="contract"
                :style="'width:800px;'"
                border
                size="mini"
              >
                <el-table-column prop="sc_name" label="合同名称" width="180">
                </el-table-column>
                <el-table-column prop="name" label="合同起始时间" width="180">
                  <template #default="scope">
                    {{ scope.row.start_time }} - {{ scope.row.end_time }}
                  </template>
                </el-table-column>
                <el-table-column label="签署方式">
                  <template #default="scope">
                    {{
                      scope.row.sc_type === OFFLINE_CONTART
                        ? "线下合同"
                        : "线上合同"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="sign_time" label="签署时间">
                </el-table-column>
                <el-table-column label="操作">
                  <template #default="scope">
                    <el-button
                      size="mini"
                      style="margin: 10px 3px"
                      type="primary"
                      @click="handleContractDetail(scope.row)"
                    >
                      查看合同
                    </el-button>
                    <el-button
                      size="mini"
                      style="margin: 10px 3px"
                      type="primary"
                      @click="handleContractDel(scope.$index)"
                    >
                      删除合同
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleManagementSubmit">
              提交
            </el-button>
          </el-form-item>

          <!-- 添加合同弹窗 -->
          <el-dialog
            :title="isLookContract ? '查看合同' : '添加合同'"
            :visible.sync="addContractVisible"
            width="40%"
            center
            @close="handleContractCancel"
          >
            <el-form ref="contractForm" :model="contractForm">
              <el-form-item label="合同/协议名称" required>
                <el-input
                  v-model="contractForm.sc_name"
                  :disabled="isLookContract"
                  style="width: 80%; float: left"
                  placeholder="请输入合同/协议名称"
                  maxlength="20"
                  show-word-limit
                />
              </el-form-item>
              <el-form-item label="合同签署时间" required>
                <el-date-picker
                  v-model="contractForm.sign_time"
                  :disabled="isLookContract"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择合同签署时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="起止时间" required>
                <el-date-picker
                  v-model="contractForm.create_time"
                  :disabled="isLookContract"
                  :default-time="['00:00:00', '23:59:59']"
                  type="datetimerange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                />
              </el-form-item>
              <el-form-item label="扫描件" required>
                <UploadCommonTemplate
                  v-model="contractForm.scan_image"
                  :disabled="isLookContract"
                  :origin="origin"
                  :accept="'image/*,.pdf'"
                  @preview-image="previewImage"
                />
              </el-form-item>
              <el-form-item
                v-show="
                  isLookContract && contractForm.sc_type !== OFFLINE_CONTART
                "
                label="合同内容"
              >
                <div v-html="contractForm.sc_content" />
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleContractCancel"> 取 消 </el-button>
              <el-button
                type="primary"
                :disabled="isLookContract"
                @click="handleContractAdd"
              >
                确 定
              </el-button>
            </div>
          </el-dialog>
        </template>
      </el-tab-pane>
      <el-tab-pane label="爆版权限" name="fourth">
        <el-form-item label="爆版手机账号">
          <el-input
            v-model="form.baobmobile"
            :disabled="!!baobmobile"
            placeholder="请输入手机账号"
            style="width: 30%"
          >
            <el-button v-if="!baobmobile" slot="append" @click="getShopList">
              获取店铺列表
            </el-button>
            <el-button v-if="baobmobile" slot="append" @click="unBindingBaob">
              取消绑定
            </el-button>
          </el-input>
          <span>（数据同步时间：{{ data_date }}）</span>
        </el-form-item>
        <el-form-item label="爆版店铺" prop="shopId">
          <el-select v-model="form.shopId" placeholder="爆版店铺">
            <el-option
              v-for="item in shop_list"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            />
          </el-select>
          <el-button type="primary" @click="addShopVisible = true">
            新增店铺
          </el-button>
          <el-button v-if="form.supply_id" type="primary" @click="sycnWcgOrder">
            同步一手欠货至爆版店铺
          </el-button>
          <div v-if="form.wcg_order_sync_time" style="display: inline">
            (同步时间: {{ form.wcg_order_sync_time }})
          </div>
        </el-form-item>
        <el-form-item label="是否自主上款" prop="is_self">
          <!-- 开通邀约的,此项置灰 -->
          <el-select
            v-model="form.is_self"
            :disabled="form.open_deposit == '1'"
            placeholder="是否自主上款"
          >
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="自主设置一手独家款" prop="self_set_sole">
                    <el-select
                        v-model="form.self_set_sole"
                        placeholder="自主设置一手独家款"
                    >
                        <el-option
                            v-for="item in public_option"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item label="自主上款全类目" prop="is_all_style">
          <!-- 开通邀约的,此项置灰 -->
          <el-select
            v-model="form.is_all_style"
            :disabled="form.open_deposit == '1'"
            placeholder="是否自主上款全类目"
          >
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开通爆版开单" prop="is_order_ability">
          <el-select
            v-model="form.is_order_ability"
            placeholder="是否开通爆版开单"
          >
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="开通库存共享" prop="baob_stock_sharing">
          <el-select
            v-model="form.baob_stock_sharing"
            placeholder="是否开通库存共享"
          >
            <el-option
              v-for="item in public_option"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit"> 提交 </el-button>
        </el-form-item>

        <el-dialog
          title="添加店铺"
          :visible.sync="addShopVisible"
          width="40%"
          center
        >
          <el-form :model="form">
            <el-form-item label="绑定账号">
              <el-input
                v-model="form.baobmobile"
                style="width: 80%; float: left"
              />
            </el-form-item>
            <el-form-item label="店铺名称">
              <el-input
                v-model="form.shopName"
                style="width: 80%; float: left"
              />
            </el-form-item>
            <el-form-item label="店铺地址">
              <el-input
                v-model="form.shopAddress"
                style="width: 80%; float: left"
              />
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input
                v-model="form.shopPhone"
                style="width: 80%; float: left"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addShopVisible = false"> 取 消 </el-button>
            <el-button type="primary" @click="AddShop"> 确 定 </el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane v-if="setag.show" label="商家分层权限" name="setag">
        <div>商家分层权限</div>

        <el-form :model="setag.form" style="margin: 30px">
          <el-form-item label="本月专场可上款数">
            <el-input
              v-model="setag.form.limit_num"
              :disabled="setag.form.none_limit == 1"
              style="width: 160px"
              size="samll"
            />&nbsp;&nbsp;&nbsp;&nbsp;款
            <el-checkbox
              v-model="setag.form.none_limit"
              style="margin-left: 50px"
              true-label="1"
              false-label="2"
            >
              不限款数
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitSetag"> 提交 </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="小店分发设置" name="setShop">
        <StoreDistribute ref="storeDistribute" :supply-id="form.supply_id" />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="修改商家等级"
      :visible.sync="addLevelVisible"
      width="40%"
      center
    >
      <p>修改后只对当前自然月生效</p>
      <el-form :model="form">
        <el-radio-group v-model="form.update_sale_level">
          <el-radio :label="-1"> 不设置等级 </el-radio>
          <el-radio :label="0"> L0 </el-radio>
          <el-radio :label="1"> L1 </el-radio>
          <el-radio :label="2"> L2 </el-radio>
          <el-radio :label="3"> L3 </el-radio>
          <el-radio :label="4"> L4 </el-radio>
          <el-radio :label="5"> L5 </el-radio>

          <el-radio :label="6"> L6 </el-radio>
        </el-radio-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addLevelVisible = false"> 取 消 </el-button>
        <el-button type="primary" @click="updateSaleLevel"> 确 定 </el-button>
      </div>
    </el-dialog>
    <preview-image
      :imgs="dialogImageUrl"
      :show="dialogVisible"
      @closeBox="dialogVisible = false"
    />
    <!-- 邀约规则设置 -->
    <el-dialog
      :visible.sync="isShowModalInvitationRule"
      :close-on-click-modal="false"
      @close="handleInvitationModalClose"
    >
      <div slot="title" class="invitation-modal-header">
        <span class="invitation-modal-title">编辑商家邀约规则</span>
        <el-switch
          v-model="invitationForm.rule_type"
          style="display: block"
          active-value="2"
          inactive-value="1"
          active-text="新规"
          inactive-text="旧规"
        >
        </el-switch>
      </div>

      <el-form ref="invitationForm" :model="invitationForm" size="mini">
        <el-table :data="invitationForm.list" border size="mini">
          <el-table-column
            prop="invitation_category"
            align="center"
            label="商品分类"
          >
            <el-form-item
              slot-scope="{ row, $index }"
              :prop="`list.${$index}.invitation_category`"
              :rules="{ required: true, message: '必选' }"
            >
              <el-select v-model="row.invitation_category">
                <el-option
                  v-for="option in invitationRule.category"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-table-column>
          <el-table-column
            prop="forecast_days"
            align="center"
            label="前置仓备货天数"
          >
            <el-form-item
              slot-scope="{ row, $index }"
              :prop="`list.${$index}.forecast_days`"
            >
              <el-select v-model="row.forecast_days" clearable>
                <el-option
                  v-for="option in invitationRule.forecastDay"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-table-column>
          <el-table-column
            prop="is_underwriting"
            align="center"
            label="是否加流"
          >
            <el-form-item
              slot-scope="{ row, $index }"
              :prop="`list.${$index}.is_underwriting`"
            >
              <el-checkbox
                v-model="row.is_underwriting"
                :true-label="constantMap.OPEN"
                :false-label="constantMap.CLOSE"
                >是否加流</el-checkbox
              >
            </el-form-item>
          </el-table-column>
          <el-table-column
            prop="no_pre_storage_forecast_days"
            align="center"
            label="非前置仓备货天数"
          >
            <el-form-item
              slot-scope="{ row, $index }"
              :prop="`list.${$index}.no_pre_storage_forecast_days`"
            >
              <el-select v-model="row.no_pre_storage_forecast_days" clearable>
                <el-option
                  v-for="option in invitationRule.noPreStorageForecastDay"
                  :key="option.value"
                  :value="option.value"
                  >{{ option.label }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-table-column>
          <el-table-column prop="actions" align="center" label="操作">
            <el-form-item slot-scope="{ $index }">
              <el-button type="danger" @click="handleInvitationRuleDel($index)">
                删除
              </el-button>
            </el-form-item>
          </el-table-column>
        </el-table>
      </el-form>
      <el-button
        type="primary"
        plain
        size="medium"
        @click="handleInvitationRuleAdd"
      >
        新增规则
      </el-button>
      <div slot="footer">
        <el-button
          :loading="loadingInvitationSave"
          @click="isShowModalInvitationRule = false"
          >取消</el-button
        >
        <el-button
          :loading="loadingInvitationSave"
          type="primary"
          @click="handleInvitationRuleSave"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import md5 from "js-md5";
import * as dayjs from "dayjs";
import { isInteger } from "@/tool/helper.js";
import * as supplyApi from "@/controller/supply2267.js";
import Global_ from "../../components/Global.vue";
import { isSignedContractSupply, supplySettleDays } from "@/tool/const.js";
import SupplySelect from "./components/SupplySelect.vue";
import platforming from "./updateSupplyComponents/Platforming.vue";
import { getManagement, updateManagement } from "@/controller/supply.js";
import { CITY } from "@/const/CommonConst.js";
import PreviewImage from "../../components/PreviewImage.vue";
import { exitExemptExamine, setSupplyCharacter } from "@/api/update-supply.js";
import { getDoneContractDetail } from "@/controller/supplyContract.js";
import UploadCommonTemplate from "./updateSupplyComponents/UploadCommonTemplate.vue";
import rules from "@/const/rules.js";
import { completeMoneyDecimal } from "@/utils/tools/index.js";
import { validNonZeroMoney } from "@/utils/tools/validator.js";
import StoreDistribute from "./updateSupplyComponents/StoreDistribute.vue";
import LimitOfSupply from "./updateSupplyComponents/LimitOfSupply.vue";
import apiBaseURL from "@/utils/baseUrl.js";
import { getGetAttributableMarketList } from "@/openapi/erp/supply.js";
import { postReopen } from "@/openapi/erp/supplyReopenRecord.js";
import {
  postSaveInvitationRule,
  postGetInvitationRule,
} from "@/openapi/erp/preStorageInviteRule.js";

const parser = new DOMParser();
const OFFLINE_CONTART = "1";
const constantMap = {
  OPEN: "1", // 开启
  CLOSE: "2", // 关闭
  tempInvitationRule: {
    id: "",
    invitation_category: "",
    forecast_days: "",
    psp_ir_status: "1",
    no_pre_storage_forecast_days: "",
  },
  isJoinProfit: "1", // 参与折扣让利
  isNotJoinProfit: "2", // 不参与折扣让利
  deductByGoods: "1", // 待采单抵扣
  pickerOptions: {
    disabledDate: (date) => date.getTime() < Date.now(),
  },
  isPlatform: "1", // 是平台化商家
  periodProfitDay: "2", // 日结-让利账单生成周期
  periodProfitMonth: "1", // 月结-让利账单生成周期
  optionsSwitch: [
    { label: "开启", value: "1" },
    { label: "关闭", value: "2" },
  ],
};
export default {
  name: "UpdateSupply",
  components: {
    SupplySelect,
    platforming,
    UploadCommonTemplate,
    PreviewImage,
    StoreDistribute,
    LimitOfSupply,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
      if (!vm.resData) {
        vm.getSupplyPutLimit();
      }
    });
  },

  data() {
    const _this = this;
    return {
      commonRules: rules,
      constantMap,
      rulePrice: [
        rules.ruleBlur,
        { validator: validNonZeroMoney, trigger: "blur" },
      ],
      OFFLINE_CONTART,
      supply_id: "",
      no_reason_time_mark: "",
      no_reason_time_disabled: false,
      addLevelVisible: false,
      initShopId: 0,
      addShopVisible: false,
      activeName: "first",
      bank: "",
      banks: [],
      cnaps: [],
      isSignedContractSupply: [],
      supplySettleDays: [],
      statusVisible: false,
      show_wx_add: false,
      temp_arr: [],
      wx_nickname_arr: [],
      brandVisible: false,
      supplyCharacterVisible: false, // 商家性质修改弹窗
      dialogVisible: false,
      dialogImageUrl: [],
      restaurants: [],
      timeout: null,
      floor_name: "",
      supply_area: "",
      brand_name: "",
      first_category: [],
      second_category: [],
      third_category: [],
      resData: { follower: [] },
      supply: {
        list: [],
      },
      cats: [],
      pic: "",
      license: "",
      form: {
        wx_picture: "",
        front_id_card: "",
        back_id_card: "",
        settle_certificate: "",
        brand: "",
        is_signed_contract: "",
        settle_days: "",
        pg_member_id: "0",
        dg_member_id: "0",
        dgid: "0",
        is_show_brand: "1",
        is_main: 0,
        is_screenshot_for_add_goods: "0",
        is_deduct_repurchase: "1",
        supply_mobile_phone: "",
        supply_wechat: "",
        supply_action_value: 0,
        supply_name: "",
        limit_day: 7,
        plan_time_out_days: "10",
        pre_consignment_period: "", // 前置仓包销寄售期
        supplier_num: "",
        // brand_id:0,
        pgid: 0,
        father_market: 0,
        market_id: 0,
        supply_floor: "",
        status: "",
        create_time: [],
        supply_id: _this.$route.params.id,
        set_pgid: "", // 设置的代采组id
        is_scal: 1,
        is_strength: 0,
        supply_status: 1,
        reject_accept: "",
        is_default: null,
        payees: [
          {
            payee_id: 0,
            payee_name: "",
            payee_bank: "",
            payee_bank_account: "",
          },
        ],
        brands: [
          {
            brand_id: 0,
            brand_name: "",
            status: 1,
          },
        ],
        bill_merger_date: [],
        activity_fee_buckle: "1", // 账单方式
        open_qz_auto_buckle: "1", // 前置仓账单扣取
        season: [],
        supply_grade: [],
        age_group: [{}],
        pic: "",
        posters: "",
        license: "",
        avatar: "",
        styles: [],
        second_styles: [],
        category: [],
        picture: [],
        supply_video: "",
        studioPhotos: [], // 工作室照片
        cat: [],
        live_type: "",
        is_self: "",
        self_set_sole: "",
        is_all_style: "",
        is_self_need_audit: "",
        baobmobile: "",
        as_plan: "",
        supply_excess_point_goods: "1",
        goods_exempt_examine: "",
        supply_developer_admin: "",
        pre_storage_admin: "", // 前置仓跟进人
        supply_picker_group_member_id: 0,
        is_benchmarking: "0",
        open_deposit: "0",
        no_reason_return: "0",
        expand_admin_id: "0",
        take_stock_on_plan: "0",
        special_sale: "1",
        supply_character: "0", // 商家性质 默认选中“常规合作商”
        supply_level: "",
        is_return_profit: constantMap.isNotJoinProfit, // 是否参与让利销售
        return_profit_month: "", // 生效日期
        clearing_form: constantMap.deductByGoods,
        reserve_price: "",
        return_profit_rule: [],
        day_new_limit: "", // 日上新
        month_new_limit: "", // 月上新
        week_new_limit: "", // 周上新
        period_profit: "", // 让利账单生成周期{1:月结,2:日结}
        is_auto_billing: "1", // 是否自动开单
        is_auto_cancel_plan: "1", // 前置仓入库时消除待开单计划数据:{1:否;2:是}
        create_order_way: "1", // 第三方发货生成采购单方式:{1:按发货批次;2:按采购计划(销售订货单);}
        is_push_wcg_plan: "1", // 是否向wcg订单发送模拟采购计划
        is_sync_supply_stock: "1", // 是否同步库存
        return_profit_goods_type: "",
        return_profit_goods_file: null,
        // 业绩归属市场
        attributable_market_id: "",
        // 业绩归属细分市场
        attributable_market_sub_id: "",
      },
      back_id_card: "",
      settle_certificate: "",
      plan_supply_character: "0", // 商家性质弹窗选中值
      spayee: {
        payee_id: 0,
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
        cnap: "",
      },
      wx_picture_imgs: [],
      front_id_card_imgs: [],
      back_id_card_imgs: [],
      settle_certificate_imgs: [],
      scanImage: [],
      video: [],
      supply_video: "",
      supply_image: [],
      styles_data: [],
      second_styles_data: [],
      advantage: "档口优点",
      disadvantage: "档口缺点",
      citys: CITY,
      supply_character_type: [
        // 商家性质类型
        {
          label: "常规合作商",
          value: "0",
        },
        {
          label: "买手小店",
          value: "1",
        },
        {
          label: "小店渠道商",
          value: "2",
        },
      ],
      supply_status: [
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      periodProfitStatus: [
        {
          value: "1",
          label: "按月生成",
        },
        {
          value: "2",
          label: "按天生成",
        },
      ],
      Date_list: Array.from({ length: 31 }, (v, i) => i + 1),
      settle_type: [
        {
          value: "1",
          label: "常规代采",
        },
        {
          value: "2",
          label: "先货后款",
        },
      ],
      is_self_need_audit: [
        {
          value: "0",
          label: "不需要",
        },
        {
          value: "1",
          label: "需要",
        },
      ],
      // 这个反向options 0 是 1否 .. 小心小心小心小心小心小心小心
      is_scal_options: [
        {
          value: "0",
          label: "是",
        },
        {
          value: "1",
          label: "否",
        },
      ],
      public_option: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      public_option2: [
        {
          value: "1",
          label: "否",
        },
        {
          value: "2",
          label: "是",
        },
      ],
      // 是否自动开单 打通聚水潭/商陆花的商家支持该功能，【否】：不开启功能，【排单单】：当天自动开排单单，【实数单】：当天按发货的商品数量开实数单；
      is_auto_billing_option: [
        {
          value: "1",
          label: "否",
        },
        {
          value: "2",
          label: "排单单",
        },
        {
          value: "3",
          label: "实数单",
        },
      ],
      create_order_way: [
        {
          label: "采购订单=发货批次",
          value: "1",
        },
        {
          label: "采购订单=销售订货单",
          value: "2",
        },
      ],
      shop_list: [
        {
          shopId: 0,
          shopName: "无",
        },
      ],
      // take_stock_on_plan_options: [
      //   {
      //     value: "0",
      //     label: "否",
      //   },
      //   {
      //     value: "1",
      //     label: "是",
      //   },
      // ],
      options: [],
      marketList: [],
      subMarketList: [],
      floor: [],
      supply_area_list: [],
      pg_list: [],
      pickers: [],
      supply_developer: [],
      age_group_list: [],
      category: [],
      data_date: "",
      rules: {
        supplier_num: [
          {
            required: true,
            message: "请输入档口号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        is_scal: [
          {
            required: true,
            message: "请选择是否可以刷单",
            trigger: "change",
          },
        ],
        supply_status: [
          {
            required: true,
            message: "请选择商家状态",
            trigger: "change",
          },
        ],
        activity_fee_buckle: [
          {
            required: true,
            message: "请选择是活动费扣取方式",
            trigger: "change",
          },
        ],
        bill_merger_date: [
          { required: true, message: "请选择合并账单日期", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        father_market: [
          { required: true, message: "请选择市场", trigger: "change" },
        ],
        market_id: [
          {
            required: true,
            message: "请选择子市场",
            trigger: "change",
          },
        ],
        attributable_market_id: [
          {
            required: true,
            message: "请选择业绩归属市场",
            trigger: "change",
          },
        ],
        supply_floor: [
          { required: true, message: "请选择楼层", trigger: "change" },
        ],
        supply_area_id: [
          {
            required: true,
            message: "请选择区域/街",
            trigger: "change",
          },
        ],
        brand: [{ required: true, message: "请编辑品牌", trigger: "change" }],
        pgid: [
          {
            required: true,
            message: "请选择代采组",
            trigger: "change",
          },
        ],
        pg_member_id: [
          {
            required: true,
            message: "请选择代采员",
            trigger: "change",
          },
        ],
        dgid: [
          {
            required: true,
            message: "请选择次品组",
            trigger: "change",
          },
        ],
        dg_member_id: [
          {
            required: true,
            message: "请选择次品员",
            trigger: "change",
          },
        ],
        refund_member_id: [
          {
            required: true,
            message: "请选择退供员",
            trigger: "change",
          },
        ],
        limit_day: [
          {
            required: true,
            message: "请输入排单锁定天数",
            trigger: "blur",
          },
        ],
        plan_time_out_days: [rules.ruleBlur],
        is_return_profit: {
          required: true,
          message: "必选",
          trigger: "change",
        },
        day_new_limit: [
          {
            validator: (rule, value, callback) => {
              if (
                (value && Number(value) > 9999) ||
                (value && Number(value) < 0) ||
                !isInteger(Number(value))
              ) {
                return callback(new Error("日上新数仅支持“0－9999”整数"));
              }
              return callback();
            },
            trigger: "blur",
          },
        ],
        week_new_limit: [
          {
            validator: (rule, value, callback) => {
              if (
                (value && Number(value) > 9999) ||
                (value && Number(value) < 0) ||
                !isInteger(Number(value))
              ) {
                return callback(new Error("周上新数仅支持“0－9999”整数"));
              }
              return callback();
            },
            trigger: "blur",
          },
        ],
        month_new_limit: [
          {
            validator: (rule, value, callback) => {
              if (
                (value && Number(value) > 9999) ||
                (value && Number(value) < 0) ||
                !isInteger(Number(value))
              ) {
                return callback(new Error("月上新数仅支持“0－9999”整数"));
              }
              return callback();
            },
            trigger: "blur",
          },
        ],
      },
      baobmobile: null,
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/UpdateSupply",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      files: [],
      memberOption: [],
      PickerGroupMemberOption: [],
      defectiveGroupMemberOption: [],
      defectiveGroupOption: [],
      refundMemberOption: [],
      savePayeeVisible: false,
      // 商家分层的tag
      setag: {
        show: false,
        form: {
          none_limit: "2", // 是否不限制
          limit_num: "",
        },
      },
      current_developer: "",
      uploadData: {
        key: "",
        "content-type": "",
        policy: "",
        AccessKeyId: "",
        signature: "",
        success_action_status: "",
        domain: "",
        bucket: "",
      },
      uploadPath: "",
      uploadActionUrl: "",
      tokenUrl: "/open/Merchants/getObsUploadData",
      uploadHeaders: { "Content-Type": "multipart/form-data" },
      videoFlag: false,
      videoUploadPercent: 0,
      contract: [],
      addContractVisible: false,
      contractForm: {
        sc_name: "",
        create_time: [],
        scan_image: "",
        sign_time: "",
        sc_content: "",
        sc_type: "1",
      },
      level_options: [], // 档口实力等级下拉
      isShowManagement: false, // 是否展示商家经营信息
      isContractUpdate: true,
      isLookContract: false,
      fileList: [],
      action: "",
      invitationRule: {}, // 邀约池规则
      isShowModalInvitationRule: false,
      loadingInvitationSave: false,
      invitationForm: {
        list: [],
        rule_type: "1",
      },
      supplyStatusForm: {
        remark: "",
      },
      supplyStatusFormRules: {
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      supplyStatusFormModalVisible: false,
      // 小店分发
      setShopForm: {},
      refundModels: [],
      actionFile: `${apiBaseURL}/erp/supply/importReturnProfitGoods`,
      uploadParm: {
        supply_id: "",
      },
      goodsTypeFile: [],
      performanceMarketList: [],
      performanceSubMarketList: [],
    };
  },
  computed: {
    filteredForm() {
      const { form } = this;
      Object.keys(form).forEach((key) => {
        if (form[key] === undefined || form[key] === "" || form[key] === null) {
          delete form[key];
        }
      });
      return form;
    },
    otherPay() {
      // 目前pay_methods中只有两项数据，所以非此即彼，以后增多方式，逻辑要改
      const { options, form } = this;
      const hitItem = options.pay_methods?.find(
        (item) => item.value !== form.pay_method
      );
      return hitItem ?? {};
    },
  },
  watch: {
    "form.supply_character": function formSupplyCharacter(newVal) {
      this.plan_supply_character = newVal;
    },
  },
  mounted() {
    this.supply_id = this.$route.params.id;
    this.$http
      .get("/erp/Supply/getAllSupplierNum", this.filteredForm)
      .then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.restaurants = res.data.data;
        }
      });
    this.handleGetInvitationRule();
    this.handleGetPerformanceMarketList();
  },
  methods: {
    // 超出限制提醒
    limitTips() {
      this.$message({
        message: "已存在指定货号名单，如要覆盖，请先删除右侧的文件~",
        type: "error",
      });
    },
    importFile(res) {
      const { code, data, msg } = res;
      this.fileList = []; // 删除下方文件名
      if (code !== 200) {
        this.$message.error(msg);
        this.$refs.goodsTypeFileRef.clearFiles();
      } else {
        this.form.return_profit_goods_file = data.file_path;
      }
    },
    handleGetInvitationRule() {
      postGetInvitationRule({ supply_id: this.supply_id })
        .then((res) => {
          console.log("---res", res);
          this.invitationRule = res;
          this.invitationForm.list = res.rule.slice();
          this.invitationForm.rule_type = res.rule_type;
        })
        .catch(this.$noop);
    },
    AddShop() {
      this.$http
        .post("/erp/Supply/addBaobShop", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success(res.data.msg);
            // 修改后重新获取数据
            this.getShopList();
            this.addShopVisible = false;
            this.form.shopName = "";
            this.form.shopAddress = "";
            this.form.shopPhone = "";
            // this.fetchData(true);
          }
        });
    },
    getShopList() {
      this.loading = true;
      this.$http
        .post("/erp/supply/getBaobShopList", {
          baobmobile: this.form.baobmobile,
          supply_id: this.form.supply_id,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            if (res.data.code === 402) {
              const str =
                `当前此商家有${res.data.data.num}个相同的款号，共${res.data.data.kh_num}款商品。\n` +
                `若点击“立刻处理”，将会自动对以上商品修改款号\n` +
                `修改逻辑：从创建时间最早的同款商品开始添加前缀YS1-、YS2-...最新一个被创建的同款商品不会被添加前缀；\n` +
                `确定处理？`;
              this.$confirm(str, "相同款号商品", {
                confirmButtonText: "立刻处理",
                cancelButtonText: "取消",
                showClose: false,
                // type: 'warning'
              })
                .then(() => {
                  this.loading = true;
                  this.$http
                    .post("/erp/supply/autoUpdateKh", {
                      supply_id: this.form.supply_id,
                    })
                    .then((resp) => {
                      this.loading = false;
                      if (resp.data.code !== 200) {
                        this.$message.error(resp.data.msg);
                      }
                      this.$message.success(resp.data.msg);
                    });
                })
                .catch(() => {
                  return false;
                });
            } else {
              this.$message.error(res.data.msg);
            }
          } else {
            this.$message.success("获取成功");
            this.shop_list = res.data.data.shop_list;
          }
        });
    },
    unBindingBaob() {
      this.$confirm(
        "取消绑定后账号及关联店铺将被解绑，数据不会同步，店铺一手相关功能入口关闭！",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        }
      )
        .then(() => {
          this.$http
            .post("/erp/supply/unBindingBaob", {
              supply_id: this.form.supply_id,
              shopId: this.form.shopId,
            })
            .then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.fetchData(true);
              }
            });
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    getMemberOption(e) {
      if (!e) {
        return;
      }
      this.memberOption = [];
      this.form.pg_member_id = "0";
      this.loading = true;
      this.$http.post("/erp/Common/getPgMember", { pgid: e }).then((res) => {
        this.loading = false;
        if (res.data.data.length < 1) {
          this.$message.info("请先绑定代采员至该代采组下");
          return;
        }
        this.memberOption = res.data.data;
      });
    },
    getPickerGroupMemberOption(e) {
      if (!e) {
        return;
      }
      this.PickerGroupMemberOption = [];
      this.form.supply_picker_group_member_id = "0";
      this.loading = true;
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: e })
        .then((res) => {
          this.loading = false;
          if (res.data.data.length < 1) {
            this.$message.info("请先绑定买手到该买手组下");
            return;
          }
          this.PickerGroupMemberOption = res.data.data;
        });
    },
    getDefectiveGroupMember(val) {
      if (!val) {
        return;
      }
      this.form.dg_member_id = "0";
      this.form.refund_member_id = "0";
      this.defectiveGroupMemberOption = [];
      this.$http
        .post("/erp/Defective/getGroupMember", {
          dgid: val,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.defectiveGroupMemberOption = res.data.data.member;
            this.refundMemberOption = res.data.data.refundMember;
          }
        });
    },
    handleCityChange() {
      this.$http
        .post("/erp/Defective/getCityGroups", {
          city: -1,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.form.dgid = "0";
            this.form.dg_member_id = "0";
            this.defectiveGroupOption = res.data.data.group;
            this.defectiveGroupMemberOption = [];
          }
        });
    },
    addCat() {
      this.category.forEach((cat) => {
        if (cat.key == this.form.cat3) {
          if (this.cats.indexOf(cat.label) >= 0) {
            return;
          }
          this.cats.push(cat.label);
          this.form.category.push(cat);
        }
      });
    },
    setCatChild(value) {
      this.second_category = [];

      Object.keys(this.category).forEach((key) => {
        if (value == this.category[key].key) {
          this.category.forEach((cat) => {
            if (cat.parent_id == value) {
              this.second_category.push(cat);
            }
          });
        }
      });
    },
    setCatChild1(value) {
      this.third_category = [];

      Object.keys(this.category).forEach((key) => {
        if (value == this.category[key].key) {
          this.category.forEach((cat) => {
            if (cat.parent_id == value) {
              this.third_category.push(cat);
            }
          });
        }
      });
    },
    setDefaultPayee(payee) {
      this.$confirm("确定设置此账号为默认收款账号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showClose: false,
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/Supply/setDefaultPayee", {
              payee_id: payee.payee_id,
              supply_id: this.$route.params.id,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return;
              }
              this.$message.success(res.data.msg);
            });
        })
        .catch(() => {
          return false;
        });
    },
    setBenchmarking() {
      if (
        this.form.is_benchmarking == 1 &&
        (this.form.is_all_style == 0 ||
          this.form.is_self == 0 ||
          this.form.baobmobile == "" ||
          this.form.supply_picker_group_member_id == 0)
      ) {
        this.$confirm(
          "商家未绑定爆版|未开通自主上款|上款类型为非全类目上款|未绑定买手",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.is_benchmarking = "0";
            return false;
          })
          .catch(() => {
            this.form.is_benchmarking = "0";
            return false;
          });
      }
      if (this.form.is_benchmarking == 0 && this.form.is_self_need_audit == 0) {
        this.$confirm("同时修改自主上款需要审核为 需要审核", "提示", {
          confirmButtonText: "确定",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    setOpenDeposit() {
      if (this.form.open_deposit == 1 && this.form.shopId == 0) {
        this.$confirm("邀请商家自主申请入驻需要绑定爆版店铺", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (
        this.form.open_deposit == 1 &&
        this.form.supply_picker_group_member_id == 0
      ) {
        this.$confirm("邀请商家自主申请入驻需要绑定买手", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (this.form.open_deposit == 1 && this.form.is_self == 0) {
        this.$confirm("邀请商家自主申请入驻需要开通自主上款权限", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
      if (this.form.open_deposit == 1 && this.form.is_all_style == 0) {
        this.$confirm(
          "邀请商家自主申请入驻需要开通自主上款全类目权限",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showClose: false,
            type: "warning",
          }
        )
          .then(() => {
            this.form.open_deposit = "0";
            return false;
          })
          .catch(() => {
            this.form.open_deposit = "0";
            return false;
          });
      }
    },
    setSelfNeedAudit() {
      if (this.form.is_self_need_audit == 0 && this.form.is_benchmarking == 0) {
        this.$confirm("只有履约率标杆商家可以选择为 不需要审核", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.form.is_self_need_audit = "1";
            return false;
          })
          .catch(() => {
            this.form.is_self_need_audit = "1";
            return false;
          });
      }
    },
    updatePayee(payee) {
      this.loading = true;
      if (payee) {
        this.spayee = payee;
        this.setCnap();
      } else {
        this.spayee = {
          payee_id: 0,
          payee_name: "",
          payee_bank: "",
          payee_bank_account: "",
          cnap: "",
        };
      }
      this.savePayeeVisible = true;
      this.loading = false;
    },
    savePayee() {
      this.spayee.supply_id = this.$route.params.id;
      this.$http.post("/erp/supply/savePayee", this.spayee).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          if (this.spayee.payee_id == 0) {
            this.form.payees.push({
              key: Date.now(),
              payee_id: res.data.data.payee.payee_id,
              payee_name: res.data.data.payee.payee_name,
              payee_bank: res.data.data.payee.payee_bank,
              payee_bank_account: res.data.data.payee.payee_bank_account,
              cnap_name: res.data.data.payee.cnap_name,
            });
          }

          this.$message.success(res.data.msg);
          this.savePayeeVisible = false;
        }
      });
    },
    setCnap(v) {
      if (v && v.length >= 2) {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.spayee.payee_bank,
            cnap_name: v,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      } else {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.spayee.payee_bank,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      }
    },
    showWxBox() {
      const { supply_id: supplyId } = this.form;
      this.show_wx_add = true;
      this.$http
        .post("/erp/Supply/getSupplyWxNickname", {
          supply_id: supplyId,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.temp_arr = res.data.data;
          this.wx_nickname_arr = res.data.data;
          const arr = [];
          this.wx_nickname_arr.forEach((v) => {
            arr.push(v.name);
          });
          this.resData.wx_nickname = arr.join(",");
        });
    },
    handleClose() {
      this.show_wx_add = false;
      this.wx_nickname_arr = this.this.temp_arr;
    },
    addNickname() {
      this.wx_nickname_arr.push({ id: 0, name: "", status: 0 });
    },
    changeWxStatus(index) {
      if (this.wx_nickname_arr[index].status == 1) {
        this.wx_nickname_arr[index].status = 0;
      } else {
        this.wx_nickname_arr[index].status = 1;
      }
    },
    addData() {
      this.loading = true;
      this.show_wx_add = false;
      if (this.wx_nickname_arr.length <= 0) {
        this.$message.error("无可添加的数据");
        return;
      }
      this.$http
        .post("/erp/Supply/updateSupplyWxNickname", {
          data: this.wx_nickname_arr,
          supply_id: this.form.supply_id,
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success("操作成功");
          this.temp_arr = res.data.data;
          this.wx_nickname_arr = res.data.data;
        });
    },
    handleSelectCity(value, reset) {
      // 重置数据
      if (reset) {
        this.form.father_market = "";
        this.form.market_id = "";
        this.form.is_show_brand = "1";
        this.marketList = [];
        this.subMarketList = [];
      }
      this.$http
        .post("/erp/Supply/getMainMarket", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.marketList = res.data.data;
          }
        });
    },
    setChild(value, reset) {
      // 重置数据
      if (reset) {
        this.form.market_id = "";
        this.form.is_show_brand = "1";
        this.subMarketList = [];
      }
      this.$http
        .post("/erp/Supply/getChildMarket", { parent_id: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.subMarketList = res.data.data;
          }
        });
    },
    handleClose2(tag) {
      this.cats.splice(this.cats.indexOf(tag), 1);
      this.form.category.splice(this.form.category.indexOf(tag), 1);
    },
    fetchData() {
      if (this.$route.params.id) {
        const promise = this.$route.query.reopen_id
          ? postReopen(
              { id: this.$route.query.reopen_id },
              { useDataField: false }
            )
          : this.$http.get(
              `${this.url}/supply_id/${this.$route.params.id}`,
              this.filteredForm
            );
        promise.then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            this.floor = this.resData.floor;
            this.supply_area_list = this.resData.supply_area;
            this.pg_list = this.resData.pg_list;
            this.pickers = this.resData.pickers;
            this.supply_developer = this.resData.supply_developer;
            this.age_group_list = this.resData.age_group;
            this.category = this.resData.category;
            this.defectiveGroupMemberOption =
              this.resData.defectiveGroupMemberOption;
            this.defectiveGroupOption = this.resData.defectiveGroupOption;
            this.refundMemberOption = this.resData.refundMemberOption;
            this.memberOption = this.resData.member_option;
            this.refundModels = this.resData.refund_models;
            // this.options = this.resData.options;
            this.$set(this, "options", this.resData.options);

            this.PickerGroupMemberOption =
              this.resData.picker_group_member_option;
            if (res.data.data.supply.baobmobile) {
              this.$http
                .post("/erp/supply/getBaobShopList", {
                  baobmobile: res.data.data.supply.baobmobile,
                  supply_id: res.data.data.supply.supply_id,
                })
                .then((resp) => {
                  this.shop_list = resp.data.data.shop_list;
                  this.data_date = resp.data.data.data_date;
                });
            }
            // 开发人重置为空字符串 不然下拉选择会很奇怪
            if (res.data.data.supply.supply_developer_admin == 0) {
              res.data.data.supply.supply_developer_admin = "";
            }
            // 这段拿来做判断
            this.current_developer =
              res.data.data.supply.supply_developer_admin;
            this.form = res.data.data.supply;
            // 上传文件的商家id
            this.uploadParm = {
              supply_id: this.form.supply_id,
            };
            // 回显已上传的文件列表
            if (
              this.form.return_profit_goods_type === "2" &&
              this.form.return_profit_goods_file
            ) {
              const filePath = this.form.return_profit_goods_file.split("/");
              const name = filePath[filePath.length - 1];
              this.goodsTypeFile = [
                {
                  name,
                  url: this.form.return_profit_goods_file,
                },
              ];
            }
            // 直播频率默认值
            if (this.form.is_live === "0" && this.form.live_type === "0") {
              this.form.live_type = "1";
            }
            if (this.form.no_reason_begin_time !== "") {
              this.no_reason_time_disabled = true;
            }
            this.initShopId = this.form.shopId;
            this.form.is_show_brand =
              res.data.data.supply.is_show_brand.toString();

            this.license = res.data.data.supply.license;
            this.form.cat_ids = res.data.data.cats;
            if (this.marker && this.form.lng && this.form.lat) {
              this.marker.setPosition([this.form.lng, this.form.lat]);
              this.map.add(this.marker);
              this.map.setCenter([this.form.lng, this.form.lat]);
              this.map.setZoom(16);
            }
            this.baobmobile = res.data.data.supply.baobmobile;

            this.advantage = res.data.data.supply.advantage_placeholder;
            this.disadvantage = res.data.data.supply.disadvantage_placeholder;
            this.banks = res.data.data.banks;

            this.build_styles();
            this.build_second_styles();
            this.getToken();
            this.handleSelectCity(this.form.city, false);
            this.setChild(this.form.father_market, false);
            this.handleSetAttributableSubMarket(
              this.form.attributable_market_id,
              false
            );
          }
          this.getManagementFun();
        });
      }
      this.supplySettleDays = supplySettleDays;
      this.isSignedContractSupply = isSignedContractSupply;
    },
    // 查询商家经营信息
    getManagementFun() {
      getManagement({
        supply_id: this.form.supply_id,
        reopen_id: this.$route.query.reopen_id,
      })
        .then((data) => {
          this.isShowManagement = true;
          this.level_options = data.level_options;
          const {
            payees,
            is_default_payees: isDefaultPayees,
            contract,
            management,
            lat,
            lng,
            supply_address: supplyAddress,
          } = data.data;

          this.form.payees = payees;
          this.form.is_default = isDefaultPayees;
          this.contract = contract;
          this.form.studioPhotos = management.supply_images;
          this.fileList = [];
          for (let i = 0; i < this.form.studioPhotos.length; i++) {
            this.fileList.push({
              name: i,
              url: this.form.studioPhotos[i],
            });
          }
          console.log("data.data", data.data);
          this.form = {
            ...this.form,
            ...management,
            supply_address: supplyAddress,
            lat,
            lng,
          };

          // 视频回显
          this.supply_video = management.supply_video_url;
        })
        .catch((err) => {
          if (err.code === 402) {
            this.isShowManagement = false;
          } else {
            console.log(err.msg);
          }
        });
    },

    onSubmit() {
      this.loading = true;
      this.form.activeName = this.activeName;
      if (
        this.form.open_deposit == 1 &&
        this.form.supply_picker_group_member_id == 0
      ) {
        this.$confirm("开通邀约一定要绑定买手", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        });
        return;
      }
      if (this.initShopId != this.form.shopId) {
        let initShopName = "";
        let nowShopName = "";

        Object.keys(this.shop_list).forEach((key) => {
          if (this.initShopId == this.shop_list[key].shopId) {
            initShopName = this.shop_list[key].shopName;
          }
          if (this.form.shopId == this.shop_list[key].shopId) {
            nowShopName = this.shop_list[key].shopName;
          }
        });
        let msg = `绑定店铺从${initShopName}变成${nowShopName},数据及一手权限功能将同步至${nowShopName}`;
        if (!initShopName) {
          msg = `绑定店铺${nowShopName}店，数据将会同步至${nowShopName}店！`;
        }
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            this.submitForm();
          })
          .catch(() => {
            return false;
          });
      } else {
        this.submitForm();
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.filteredForm,
            reserve_price: completeMoneyDecimal(
              this.filteredForm.reserve_price
            ),
            return_profit_rule: this.filteredForm.return_profit_rule.map(
              (item) => ({ ...item, price: completeMoneyDecimal(item.price) })
            ),
            reopen_id: this.$route.query.reopen_id,
          };
          this.$http.post(this.url, params).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message({
                type: res.data.data.msg_type,
                message: res.data.data.msg,
              });
              // 修改后重新获取数据
              this.$http
                .get("/erp/Supply/getAllSupplierNum", params)
                .then((resp) => {
                  this.loading = false;
                  if (resp.data.code !== 200) {
                    this.$message.error(resp.data.msg);
                  } else {
                    this.restaurants = resp.data.data;
                  }
                });
              // 关闭当前编辑页, 返回列表页
              this.fetchData(true);
              const currentPath =
                this.$parent.$parent.$parent.$parent.filterUriPrefix(
                  this.$route.path
                );
              this.$parent.$parent.$parent.$parent.removeTab(currentPath);
              this.$router.push("/home/supply/supplyList");
            }
          });
        } else {
          this.$message.info("请完善必填信息");
        }
      });
    },
    removePayee(item) {
      if (item.payee_id > 0) {
        this.$http
          .post("/erp/Supply/removePayee", {
            payee_id: item.payee_id,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            }
          });
      }
      const index = this.form.payees.indexOf(item);
      if (index !== -1) {
        this.form.payees.splice(index, 1);
      }
    },

    addPayee() {
      this.form.payees.push({
        key: Date.now(),
        payee_id: 0,
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
      });
    },

    changeBrand(item) {
      if (item.status === 1) {
        if (this.form.brands[this.form.is_main].brand_id === item.brand_id) {
          this.$message.error("不能禁用主品牌");
          return;
        }
        this.$confirm("禁用后，该品牌下的所有商品将变为“断货”状态", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {
            if (item.brand_id > 0) {
              this.$http
                .post("/erp/Supply/changeBrand", {
                  brand_id: item.brand_id,
                  supply_id: this.$route.params.id,
                })
                .then((res) => {
                  this.loading = false;
                  if (res.data.code !== 200) {
                    this.$message.error(res.data.msg);
                    return;
                  }
                  this.$message.success(res.data.msg);
                  item.status = 0;
                });
            }
          })
          .catch(() => {
            return false;
          });
      } else if (item.brand_id > 0) {
        this.$http
          .post("/erp/Supply/changeBrand", {
            brand_id: item.brand_id,
            supply_id: this.$route.params.id,
          })
          .then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              return;
            }
            this.$message.success(res.data.msg);
            /* eslint no-param-reassign: ["error", { "props": false }] */
            item.status = 1;
          });
      }
    },
    addBrand() {
      this.form.brands.push({
        key: Date.now(),
        brand_id: 0,
        brand_name: "",
        status: 1,
      });
    },
    setBrand() {
      this.form.brand = "";

      const valueArr = this.form.brands.map((item) => item.brand_name);
      const isDuplicate = valueArr.some((item, idx) => {
        return valueArr.indexOf(item) !== idx;
      });

      if (isDuplicate) {
        this.$message.error("品牌名不能重复", "提示");
        return;
      }

      this.form.brand = valueArr.join(",");

      this.genSupplyName();
      this.brandVisible = false;
    },
    // 查询
    querySearch(queryString, cb) {
      const { restaurants } = this;
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect() {},
    changeStatus() {
      // if(value==0){
      this.statusVisible = true;
      // }
    },
    genSupplyName() {
      if (this.form.brands[this.form.is_main].status === 0) {
        for (let i = 0; i < this.form.brands.length; i++) {
          if (this.form.brands[i].status === 1) {
            this.form.is_main = i;
            break;
          }
        }
        this.$message.error("禁用品牌不能设为主品牌");
        return;
      }

      Object.keys(this.floor).forEach((key) => {
        if (this.form.supply_floor == this.floor[key].value) {
          this.floor_name = this.floor[key].label;
        }
      });

      Object.keys(this.supply_area_list).forEach((key) => {
        if (
          this.form.supply_area_id == this.supply_area_list[key].supply_area_id
        ) {
          this.supply_area = this.supply_area_list[key].supply_area;
        }
      });

      this.brand_name = this.form.brands[this.form.is_main].brand_name;
      if (this.form.supply_area_id == 0) {
        this.form.supply_name = `${this.floor_name}-${this.form.supplier_num}-${this.brand_name}`;
      } else {
        this.form.supply_name = `${this.floor_name}-${this.supply_area}-${this.form.supplier_num}-${this.brand_name}`;
      }
    },
    // 图片
    getSizeArr(val) {
      Object.keys(val.all_item).forEach((key) => {
        if (val.co_val == key) {
          this.$set(val, "sizeval_ary", val.all_item[key]);
        }
      });
      // 清空已经上次选择的尺码
      this.$set(val, "si_val", "");
    },
    handleExceed() {
      this.$message.warning("最多只能上传9张");
    },
    deleteImg(url, index) {
      if (this.form.studioPhotos.indexOf(url) >= 0) {
        this.form.studioPhotos.splice(index, 1);
        this.fileList.splice(index, 1);
      }
    },
    beforeStudioPhotosUpload(file) {
      this.uploadData.key = `obs/erp/upload/${dayjs().format(
        "YYYY/MM/DD"
      )}/${md5(file.name + Date.now())}.${file.name
        .toLowerCase()
        .split(".")
        .splice(-1)}`;
    },
    beforeVideoUpload(file) {
      if (this.supply_video !== "") {
        this.$message.warning("只能上传一个视频");
        return;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 50) {
        this.$message.error(
          `视频太大了,请缩小到50MB以内再上传,当前图片大小:${size}MB`
        );
        return;
      }
      // 赋值上传文件
      this.uploadData["content-type"] = file.type;
      const time = new Date();
      const date = `${time.getFullYear()}${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }${time.getDate()}${time.getTime()}`;
      const year = `${time.getFullYear()}`;
      const month = `${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }`;
      const { name } = file;
      const prev = md5(date + name.split(".")[0]);
      const next = name.split(".")[name.split(".").length - 1];
      this.uploadData.key = `${
        this.uploadPath + year
      }/${month}/${prev}.${next}`;
      this.uploadData["content-type"] = file.type;
    },
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent = +file.percentage.toFixed(0);
    },
    getToken() {
      this.$http.get(this.tokenUrl).then((res) => {
        if (res.data.code === 200) {
          const r = res.data.data;
          this.uploadData.AccessKeyId = r.uptoken.access_key_id;
          this.uploadData.domain = r.uptoken.domain;
          this.uploadData.policy = r.uptoken.policy;
          this.uploadData.signature = r.uptoken.signature;
          this.uploadData.success_action_status =
            r.uptoken.success_action_status;
          this.uploadData.bucket = r.bucket_name;
          const endPoint = r.endpoint;
          this.uploadActionUrl = `https://${this.uploadData.bucket}.${endPoint}/`;
          this.uploadPath = r.path;
        }
      });
    },
    previewImage(url) {
      // const newUrl = new URL(this.origin,url)
      // 判断是否有域名
      if (url.indexOf(this.origin) > -1) {
        this.dialogImageUrl = [url];
      } else {
        this.dialogImageUrl = [`${this.origin}/${url}`];
      }
      this.dialogVisible = true;
    },
    previewStudioPhoto(url) {
      this.dialogImageUrl = [url];

      this.dialogVisible = true;
    },
    deleteVideo() {
      this.supply_video = "";
      this.form.supply_video = "";
    },

    uploadSuccessVideo() {
      this.videoFlag = false;
      const video = `${this.origin}/${this.uploadData.key}`;
      this.form.supply_video = video;
      this.supply_video = video;
    },
    handleRemove(file) {
      const index = this.fileList.findIndex((item) => item.name === file.name);
      this.fileList.splice(index, 1);
    },
    uploadSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          const xmlDoc = parser.parseFromString(item.response, "text/xml");
          item.name = xmlDoc.querySelector("Key").innerHTML;
          item.url = `${this.uploadActionUrl}${item.name}`;
        }
        return item;
      });
      this.form.studioPhotos = this.fileList.map((item) => item.url);
    },
    updateSaleLevel() {},
    returnData(e) {
      this.form.is_signed_contract = e.is_signed_contract;
      this.form.settle_days = e.settle_days;
    },
    sycnWcgOrder() {
      this.$confirm("是否同步一手代采单至爆版店铺 ?", "同步提示", {
        closeOnClickModal: false,
      }).then(() => {
        const { supply_id: supplyId } = this.form;
        this.$http
          .post("/erp/Supply/syncWcgOrderToBaob", { supply_id: supplyId })
          .then((rs) => {
            if (rs.data.code !== 200) {
              this.$message.error(rs.data.msg);
              return;
            }
            if (rs.data.data) {
              this.form.wcg_order_sync_time = rs.data.data;
            }
            this.$message.success("同步成功");
          });
      });
    },
    build_second_styles(value, direction) {
      this.second_styles_data = [];
      const { style } = this.resData;
      if (this.form.styles) {
        for (let i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is =
            this.form.styles.some((v) => style[i].key === v) &&
            !this.form.second_styles.includes(style[i].key);
          if (is) {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
        // 点击左侧按钮需要再检测下副风格的选择项
        if (direction === "left") {
          this.build_styles();
        }
      }
    },
    build_styles(value, direction) {
      this.styles_data = [];
      const { style } = this.resData;
      if (this.form.second_styles) {
        for (let i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is =
            this.form.second_styles.some((v) => style[i].key === v) &&
            !this.form.styles.includes(style[i].key);
          if (is) {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
        // 点击左侧按钮需要再检测下主风格的选择项
        if (direction === "left") {
          this.build_second_styles();
        }
      }
    },

    // 获取商家可上款数
    getSupplyPutLimit() {
      this.$http
        .post("/erp/Supply/getSupplyPutLimit", {
          supply_id: this.$route.params.id,
        })
        .then((rs) => {
          // 没有获得
          if (rs.data.code !== 200) {
            return;
          }
          // 显示分层的tag
          this.$set(this.setag, "show", true);
          this.$set(this.setag, "form", rs.data.data);
        });
    },

    // 提交商家分层
    submitSetag() {
      // console.log(this.setag.form);
      this.$set(this.setag.form, "supply_id", this.$route.params.id);
      this.$http
        .post("/erp/Supply/setSupplyPutLimit", this.setag.form)
        .then((rs) => {
          if (rs.data.code !== 200) {
            this.$message.e(rs.data.msg);
            return;
          }
          this.$message.success("保存成功");
        });
      // 关闭当前编辑页, 返回列表页
      this.fetchData(true);
      const currentPath = this.$parent.$parent.$parent.$parent.filterUriPrefix(
        this.$route.path
      );
      this.$parent.$parent.$parent.$parent.removeTab(currentPath);
      this.$router.push("/home/supply/supplyList");
    },
    // 退出免审
    handleExitAbsolveReview() {
      const params = {
        supply_id: this.form.supply_id,
        goods_exempt_examine: "0",
      };
      this.$confirm("退出免审请确认操作，是否退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          exitExemptExamine(params).then((res) => {
            if (res.data.code !== 200) {
              this.$message.e(res.data.msg);
              return;
            }
            this.$message.success("退出免审操作成功!");
            // 关闭当前编辑页, 返回列表页
            this.fetchData(true);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 设置商家商家性质
    handleSetSupplyCharacter() {
      const params = {
        supply_id: this.form.supply_id,
        supply_character: this.plan_supply_character,
      };
      setSupplyCharacter(params).then((res) => {
        // 关闭弹窗
        this.supplyCharacterVisible = false;
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
          return;
        }
        this.form.supply_character = this.plan_supply_character;
        this.$message.success("修改商家性质操作成功!");
        // 重载数据
        this.fetchData(true);
      });
    },
    // 设置商家商家性质 取消 关闭弹窗
    handleResetSupplyCharacter() {
      // 重置参数
      this.plan_supply_character = this.form.supply_character;
      // 关闭弹窗
      this.supplyCharacterVisible = false;
    },
    handleContractCancel() {
      this.contractForm = this.$options.data.call(this).contractForm;
      this.scanImage = [];
      this.addContractVisible = false;
      this.isLookContract = false;
    },
    // 删除合同
    handleContractDel(index) {
      this.$confirm("是否确认删除该合同", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        this.contract.splice(index, 1);
      });
    },
    // 合同详情
    handleContractDetail(row) {
      this.contractForm = row;
      this.contractForm.create_time = [row.start_time, row.end_time];
      this.isLookContract = true;
      if (row.sc_type === OFFLINE_CONTART) {
        this.addContractVisible = true;
      } else {
        getDoneContractDetail({ sc_id: row.sc_id }).then((data) => {
          this.addContractVisible = true;

          this.contractForm.sc_content = data.sc_content;
          this.contractForm.scan_image = data.scan_image;
        });
      }
    },
    // 新增合同
    handleContractAdd() {
      if (this.contractForm.sc_name === "") {
        this.$message("合同/协议名称不能为空");
        return;
      }
      if (this.contractForm.sign_time === "") {
        this.$message("签署时间必选");
        return;
      }
      if (this.contractForm.create_time.length === 0) {
        this.$message("起止时间必选");
        return;
      }
      if (this.contractForm.scan_image.length === 0) {
        this.$message("请上传扫描件");
        return;
      }
      this.isContractUpdate = false;
      this.$nextTick(() => {
        this.contract.push({
          sc_id: 0,
          sc_name: this.contractForm.sc_name,
          sc_type: this.contractForm.sc_type || OFFLINE_CONTART,
          start_time: this.contractForm.create_time[0],
          end_time: this.contractForm.create_time[1],
          scan_image: this.contractForm.scan_image,
          sign_time: this.contractForm.sign_time,
        });
        this.isContractUpdate = true;
        this.handleContractCancel();
      });
    },
    handleManagementSubmit() {
      const params = {
        posters: this.form.posters,
        avatar: this.form.avatar,
        license: this.form.license,
        wx_picture: this.form.wx_picture,
        wx_no: this.form.wx_no,
        supply_video: this.form.supply_video,
        supply_images: this.form.studioPhotos,
        supply_mobile_phone: this.form.supply_mobile_phone,
        supply_wechat: this.form.supply_wechat,
        pic: this.form.pic,
        picture: this.form.picture,
        supply_level: this.form.supply_level,
        front_id_card: this.form.front_id_card,
        back_id_card: this.form.back_id_card,
        settle_certificate: this.form.settle_certificate,
        payees: this.form.payees,
        is_default: this.form.is_default,
        supply_id: this.form.supply_id,
        contracts: this.contract,
        supply_address: this.form.supply_address,
        lng: this.form.lng,
        lat: this.form.lat,
      };

      for (const key in params) {
        if (params[key] === undefined || params[key] === "undefined") {
          params[key] = "";
        }
      }

      updateManagement(params)
        .then((data) => {
          if (data === "") {
            this.$message.success("保存成功");
          }
        })
        .catch(this.$noop);
    },
    // 切换tabs
    handleTabsClick() {
      // 商家经营信息
      if (this.activeName === "BusinessInfo") {
        this.getManagementFun();
      }
    },
    handlePayMethodExchange() {
      const { supply_id: supplyId } = this.form;
      this.$confirm(
        "分账转为转账即时生效，转账转为分账需要第二天生效",
        `确认切换到${this.otherPay.label}`
      )
        .then(() => {
          supplyApi
            .updatePayMethod(
              {
                supply_id: supplyId,
                pay_method: this.otherPay.value,
              },
              { useToast: false }
            )
            .then(() => {
              console.log("value", this.otherPay.value);
              this.$message.success("切换成功");
              // 赋值到对应选项
              this.form.pay_method = this.otherPay.value;
            })
            .catch((err) => {
              this.$message.error(err.msg);
            });
        })
        .catch(this.$noop);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    handleError(err, file, fileList) {
      this.$message.warning("图片上传失败，请重新上传");
      this.fileList = fileList.filter((item) => item.status !== "fail");
    },
    handleInvitationRuleEdit() {
      this.isShowModalInvitationRule = true;
    },
    handleInvitationRuleAdd() {
      this.invitationForm.list.push({ ...constantMap.tempInvitationRule });
    },
    handleInvitationRuleDel(index) {
      this.invitationForm.list.splice(index, 1);
    },
    handleInvitationRuleSave() {
      this.$refs.invitationForm.validate((valid) => {
        if (valid) {
          this.loadingInvitationSave = true;
          const { list, rule_type: ruleType } = this.invitationForm;
          postSaveInvitationRule({
            supply_id: this.supply_id,
            rule: list,
            rule_type: ruleType,
          })
            .then(() => {
              this.isShowModalInvitationRule = false;
              this.$message.success("保存成功");
              this.handleGetInvitationRule();
            })
            .catch(this.$noop)
            .finally(() => {
              this.loadingInvitationSave = false;
            });
        }
      });
    },
    handleInvitationModalClose() {
      this.$refs.invitationForm.resetFields();
      this.invitationForm.list = this.invitationRule.rule.slice();
    },
    handleReturnProfitRuleAdd() {
      this.form.return_profit_rule.push({ num: "", price: "" });
    },
    handleReturnProfitRuleDel(index) {
      this.form.return_profit_rule.splice(index, 1);
    },
    handleSupplyStatusModalClose() {
      this.supplyStatusFormModalVisible = false;
      this.$refs.supplyStatusFormRef.resetFields();
      this.supplyStatusForm = this.$options.data.call(this).supplyStatusForm;
    },
    handleSupplyStatusModalConfirm() {
      this.$refs.supplyStatusFormRef.validate((valid) => {
        if (valid) {
          supplyApi
            .updateSingleSupplyStatus({
              supply_id: this.supply_id,
              status: this.form.supply_status.toString() === "1" ? "0" : "1",
              remark: this.supplyStatusForm.remark,
            })
            .then(() => {
              this.$message.success("修改成功");
              this.handleSupplyStatusModalClose();
              this.fetchData();
            })
            .catch(this.$noop);
        }
      });
    },
    // 商家权限提交
    limitOfSupplySubmit(submitFormData) {
      this.form = submitFormData;
      this.onSubmit();
    },
    handleGetPerformanceMarketList() {
      getGetAttributableMarketList()
        .then((res) => {
          this.performanceMarketList = res;
        })
        .catch(this.$noop);
    },
    handleViewVideo(url) {
      window.open(url);
    },
    handleSetAttributableSubMarket(attributableMarketId, reset) {
      const selectedMainMarket = this.performanceMarketList.find(
        (option) => option.attributable_market_id === attributableMarketId
      );
      this.performanceSubMarketList = selectedMainMarket?.sub_list || [];
      if (
        reset ||
        !this.performanceSubMarketList.length ||
        this.form.attributable_market_sub_id.toString() === "0"
      ) {
        this.form.attributable_market_sub_id = "";
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.select-option-tips {
  color: #606266;
  margin-left: 10px;
}

.address-view {
  position: relative;
  display: inline-block;
  width: 600px;
  margin-right: 20px;
}

.address-view-list {
  width: 100%;
  height: 200px;
  background: white;
  border: 1px solid #eee;
  position: absolute;
  overflow-y: auto;
  top: 40px;
  left: 0;
  z-index: 2;
}

.address-item {
  padding: 10px 20px;
  cursor: pointer;
  line-height: 20px;
}

.address-item:hover {
  background: #eee;
}

.open-qz-span {
  color: red;
  display: inline-block;
  margin-left: 50px;
}

.activity-free-buckle-span {
  color: #444;
  display: inline-block;
  margin-left: 82px;
}

.shop-card {
  width: 1000px;
}

.shop-card .el-card__body {
  padding: 12px;
}

.checkbox-wrap {
  display: flex;
  align-items: center;
}

.checkbox-wrap.second {
  margin-top: 8px;
}

.invitation-modal-header {
  display: flex;
  align-items: center;
}

.invitation-modal-title {
  font-size: 22px;
  margin-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/UpdateSupply.vue